<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  header="Create Recurring Job"
  [style]="{ width: '600px' }"
  [modal]="true"
  [responsive]="false"
  (onShow)="onShow()"
>
  <div class="field">
    <label>Method</label>
    <p-listbox
      class="w-full"
      [listStyle]="{ 'max-height': '250px' }"
      [options]="availableMethods"
      [formControl]="formGroup.controls.methodName"
    >
      <p-footer> Selected: {{ formGroup.controls.methodName.value }} </p-footer>
    </p-listbox>
  </div>
  <div class="field">
    <label for="description">Description</label>
    <textarea
      class="w-full"
      id="description"
      pInputTextarea
      [formControl]="formGroup.controls.description"
    ></textarea>
  </div>
  <div class="field">
    <label for="cronSchedule">Queue</label>
    <input class="w-full" pInputText [formControl]="formGroup.controls.queueName" />
  </div>
  <div class="field">
    <label for="cronSchedule">Cron String</label>
    <input
      class="w-full"
      id="cronSchedule"
      pInputText
      [formControl]="formGroup.controls.cronSchedule"
    />
    <span class="text-red-600" *ngIf="formGroup.controls.cronSchedule.invalid">
      {{ formGroup.controls.cronSchedule.errors.invalidCronExpression.message }}
    </span>
    <span *ngIf="formGroup.controls.cronSchedule.valid">
      {{ formGroup.controls.cronSchedule.value | cronHumanize }}
    </span>
    <div>
      See <a href="https://crontab.cronhub.io/" target="_blank">https://crontab.cronhub.io/</a>
    </div>
  </div>

  <p-footer>
    <button pButton label="Cancel" (click)="visibleChange.emit(false)"></button>
    <button
      pButton
      class="ui-button-success"
      label="Create"
      (click)="onSubmit()"
      [disabled]="formGroup.invalid"
    ></button>
  </p-footer>
</p-dialog>
